const LOADING_ERROR_TEXT = {
  TITLE: 'Opa, não deu para carregar essa página.',
  SUBTITLE:
    'Aconteceu um erro por aqui. Você precisa atualizar para tentar de novo.',
  BUTTON: 'Atualizar'
};

export default LOADING_ERROR_TEXT;
